import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {VideoInfo, VideoPlatformId, VideoRow} from './video-types';

export abstract class VideoPlatformConfig {
  abstract readonly name: string;
  abstract readonly id: VideoPlatformId;
  abstract readonly patterns: RegExp[];
  abstract readonly exampleLink: string;

  readonly httpHeaders = new HttpHeaders({
    Accept: 'application/json',
    'X-IGNORE-TOKEN': 'yes',
    'ngsw-bypass': '1'
  });

  abstract getInfo(row: VideoRow, http: HttpClient): Observable<VideoInfo>;

  getPreview(_row: VideoRow): string {
    return '';
  }

  getEmbedUrl(_row: VideoRow): string {
    return '';
  }


  getVideoCode(row: VideoRow): string {
    if (!row || (!row.link && !row.code)) {
      return '';
    }

    if (row.code) {
      return row.code;
    }

    const match = this.patterns
      .map(pattern => pattern.exec(row.link))
      .find(m => m && m[1]);

    return match?.[1] || '';
  }

  protected createEmptyInfo(row: VideoRow): Observable<VideoInfo> {
    return of({
      preview: '',
      title: '',
      link: row.link || ''
    });
  }
}
